import api from "@/shared/api";

export async function listProviderApplications(filters = {}) {
  try {
    const response = await api.get("/partners/applications", {
      params: filters,
    });
    return response;
  } catch (error) {
    return {
      success: false,
      error: error.message || "Failed to list applications",
    };
  }
}

export async function markProviderFormReceived(applicationId) {
  try {
    return await api.post(`/partners/applications/${applicationId}/form-received`);
  } catch (error) {
    return {
      success: false,
      error: error.message || "Failed to mark form received",
    };
  }
}

export async function verifyProviderApplication(applicationId, notes = "") {
  try {
    return await api.post(`/partners/applications/${applicationId}/verify`, {
      notes,
    });
  } catch (error) {
    return {
      success: false,
      error: error.message || "Failed to verify application",
    };
  }
}

export async function rejectProviderApplication(applicationId, notes = "") {
  try {
    return await api.post(`/partners/applications/${applicationId}/reject`, {
      notes,
    });
  } catch (error) {
    return {
      success: false,
      error: error.message || "Failed to reject application",
    };
  }
}
